export default __webpack_public_path__ + "d8850f259353f498ed22713bf7c338da.svg";